import React from "react"
import { Row } from "reactstrap"

// ─── Helpers ──────────────────────────────────────────────────────────────────
const isEmpty = val =>
  val === null ||
  val === undefined ||
  String(val).trim() === "" ||
  String(val).trim().toLowerCase() === "null" ||
  String(val).trim().toLowerCase() === "undefined"

const clean = val => (isEmpty(val) ? "" : val)
const inputCls = val => `form-control ${isEmpty(val) ? "border-danger" : ""}`

const toNum = val => (isEmpty(val) ? 0 : parseFloat(val) || 0)

const fmt = val =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(val)
 
// ─── Component ────────────────────────────────────────────────────────────────
const ZithasCtc = ({ zithasCTC }) => {
  const earnings = [
    { key: "basic_pay",            label: "B.P",   title: "Basic Pay" },
    { key: "dearness_allowance",   label: "D.A",   title: "Dearness Allowance" },
    { key: "medical_allowance",    label: "M.A",   title: "Medical Allowance" },
    { key: "house_rent_allowance", label: "H.R.A", title: "House Rent Allowance" },
    { key: "conveyance_allowance", label: "C.A",   title: "Conveyance Allowance" },
  ]

  const deductions = [
    { key: "employee_state_insurance", label: "E.S.I", title: "Employee State Insurance" },
    { key: "provident_fund",           label: "P.F",   title: "Provident Fund" },
    { key: "professional_tax",         label: "P.T",   title: "Professional Tax" },
    { key: "other_deduction",          label: "C/O.D", title: "Canteen/Other Deduction" },
  ]

  const totalEarnings   = earnings.reduce((s, { key }) => s + toNum(zithasCTC?.[key]), 0)
  const totalDeductions = deductions.reduce((s, { key }) => s + toNum(zithasCTC?.[key]), 0)
  const netSalary       = totalEarnings - totalDeductions

  return (
    <>
      <div>
        {/* ── Earnings ───────────────────────────────────────────────────── */}
        <div className="mb-3 p-4 bg-white shadow">
          <Row className="mb-5">
            <div className="col-md-4">
              <h4 className="text-dark above">Zithas CTC</h4>
            </div>

            {/* Net Salary Banner */}
            <div className="col-md-8 mb-3 mb-md-0">
              <div
                className="d-flex align-items-center justify-content-between px-4 py-2 rounded"
                style={{
                  background: "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)",
                  border: "1px solid #ddd6fe",
                }}
              >
                <div className="d-flex gap-4 align-items-center">
                  <div>
                    <p className="mb-0" style={{ fontSize: 10, textTransform: "uppercase", letterSpacing: "0.6px", color: "#6d5fa6" }}>
                      Total Earnings
                    </p>
                    <p className="mb-0 fw-semibold" style={{ fontSize: 15, color: "#15803d" }}>
                      {fmt(totalEarnings)}
                    </p>
                  </div>
                  <span style={{ color: "#c4b5fd", fontSize: 18 }}>−</span>
                  <div>
                    <p className="mb-0" style={{ fontSize: 10, textTransform: "uppercase", letterSpacing: "0.6px", color: "#6d5fa6" }}>
                      Total Deductions
                    </p>
                    <p className="mb-0 fw-semibold" style={{ fontSize: 15, color: "#dc2626" }}>
                      {fmt(totalDeductions)}
                    </p>
                  </div>
                  <span style={{ color: "#c4b5fd", fontSize: 18 }}>=</span>
                </div>
                <div className="text-end">
                  <p className="mb-0" style={{ fontSize: 10, textTransform: "uppercase", letterSpacing: "0.6px", color: "#6d5fa6" }}>
                    Net Monthly Salary
                  </p>
                  <p className="mb-0 fw-bold" style={{ fontSize: 22, color: "#6d28d9" }}>
                    {fmt(netSalary)}
                  </p>
                </div>
              </div>
            </div>
          </Row>

          <div className="d-flex align-items-center justify-content-between mb-4">
            <h5 className="mb-0 text-dark">Earnings</h5>
           
          </div>

          <Row>
            {earnings.map(({ key, label, title }) => (
              <div className="col-md-3 mb-3" key={key}>
                <label>
                  {label}{" "}
                  <i title={title} className="bx bx-info-circle ms-1 info-icon"></i>
                </label>
                <input
                  type="text"
                  placeholder={`Enter ${title}`}
                  className={inputCls(zithasCTC?.[key])}
                  value={clean(zithasCTC?.[key])}
                  disabled={true}
                />
              </div>
            ))}
          </Row>
        </div>

        {/* ── Deductions ─────────────────────────────────────────────────── */}
        <div className="mb-3 p-4 bg-white shadow">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h5 className="mb-0 text-dark">Deductions</h5>
             
          </div>

          <Row>
            {deductions.map(({ key, label, title }) => (
              <div className="col-md-3 mb-3" key={key}>
                <label>
                  {label}{" "}
                  <i title={title} className="bx bx-info-circle ms-1 info-icon"></i>
                </label>
                <input
                  type="text"
                  placeholder={`Enter ${title}`}
                  className={inputCls(zithasCTC?.[key])}
                  value={clean(zithasCTC?.[key])}
                  disabled={true}
                />
              </div>
            ))}
          </Row>
        </div>

        {/* ── Per Hour Rate + Net Salary ─────────────────────────────────── */}
        <div className="mb-3 p-4 bg-white shadow">
          <h5 className="mb-4 text-dark">Per Hour Rate</h5>
          <Row className="align-items-center">
            <div className="col-md-3 mb-3 mb-md-0">
              <label>
                P.H.R{" "}
                <i title="Per Hour Rate" className="bx bx-info-circle ms-1 info-icon"></i>
              </label>
              <input
                type="text"
                placeholder="Enter Per Hour Rate"
                className={inputCls(zithasCTC?.per_rate_hour)}
                value={clean(zithasCTC?.per_rate_hour)}
                disabled={true}
              />
            </div> 
          </Row>
        </div>
      </div>
    </>
  )
}

export default ZithasCtc